const firestore = {
  firestorePath: '/chat',
  firestoreRefType: 'collection',
  moduleName: 'chat',
  statePropName: 'chat',
  namespaced: true,
  serverChange: {
    convertTimestamps: {
      created_at: '%convertTimestamp%',
      updated_at: '%convertTimestamp%',
    },
  },
  sync: {
    debounceTimerMs: 1,
    guard: ['created_by', 'updated_by']
  }
};
export default firestore;